import axios from 'axios';
import moment from 'moment';
import {errorHandler} from "./libs/lib";

const baseurl = 'loan';
const addKeys = ['tgl1','tgl2','loan_id','customerID','debtorFullName','type_os','comparison','osamt',
'type_disbursement','comparison_disbuesement','disbursement_amount','pjxkey'
];
export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.loan_amount = meta.loan_amount;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    report(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                console.log('str',str);
                const url = `/${baseurl}/report${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `loan_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    detail(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    // UPLOAD SECTION
    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {
                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                    fd.append(key, obj[key]);
                    // }
                }
                const { data } = await axios.post(`${baseurl}/uploadcoltodb`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reprocessDataUpload(obj){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/reprocess-data-upload`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    prosesOutstandingLoan(obj){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/proses-outstanding-loan`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    prosesOutstandingLoanBulk(obj){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/proses-outstanding-loan-bulk`, obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    uploadWO(file,obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', file, file.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const data = await axios.post(`${baseurl}/upload-wo`, fd)
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    listWo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/list-wo`);
                obj.total = data.length;
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

}